const initState = {
  seasonLoading: false,
  loading: false,
  athleteFootballBadges: [],
  athleteBasketballBadges: [],
  athletebaseballBadges: [],
  athleteSoccerBadges: [],
  athleteVolleyballBadges: [],
  athleteTrackandFieldBadges: [],
  athleteCrossCountryBadges: [],
  athleteTennisBadges: [],
  athleteWrestlingBadges: [],
  athleteSoftballBadges: [],
  athleteSwimmingDivingBadges: [],
  athleteGolfBadges: [],
  athleteCompetitiveCheerSpiritBadges: [],
  athleteLacrosseBadges: [],
  athleteFlagFootballBadges: [],
  athleteBowlingBadges: [],
  athleteFieldHockeyBadges: [],
  athleteWaterPoloBadges: [],
  athleteIceHockeyBadges: [],
  athleteWeightliftingBadges: [],
  athleteGymnasticsBadges: [],
  athleteBeachVolleyballBadges: [],
  athleteSkiingAlpineSkiingBadges: [],
  athleteBadmintonBadges: [],
  athleteEsportsBadges: [],
  athleteRugbyBadges: [],
  athleteArcheryBadges: [],
  athleteFishingBadges: [],
  athleteFencingBadges: [],
  athleteOtherBadges: [],

  athleteBadges: [],
  SeosonallastDocument: null,
  SeosonalhasMoreDocument: true,
};

const seasonReducer = (state = initState, action) => {
  switch (action.type) {
    case "ADD_SEASONAL_RATING":
      let ratingSeasonal = state.athleteBadges.map((item) =>
        item.id === action.payload ? { ...item, managerRating: true } : item
      );
      return {
        ...state,
        athleteBadges: ratingSeasonal,
      };
    case "ATHLETE_BADGES":
      return {
        ...state,
        athleteBadges: action.payload.data,
        SeosonalhasMoreDocument: action.payload.hasMoreDocument,
        SeosonallastDocument: action.payload.lastDocument,
      };
    case "ATHLETE_BADGES_MORE":
      return {
        ...state,
        athleteBadges: [...state.athleteBadges, ...action.payload.data],
        SeosonalhasMoreDocument: action.payload.hasMoreDocument,
        SeosonallastDocument: action.payload.lastDocument,
      };
    case "Loading":
      return {
        ...state,
        seasonLoading: action.payload,
      };
    case "UPDATE_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case "ATHLETE_FOOTBALL_BADGES":
      return {
        ...state,
        athleteFootballBadges: action.payload,
      };
    case "ATHLETE_BASKETBALL_BADGES":
      return {
        ...state,
        athleteBasketballBadges: action.payload,
      };
    case "ATHLETE_BASEBALL_BADGES":
      return {
        ...state,
        athletebaseballBadges: action.payload,
      };
    
    case "ATHLETE_SOCCER_BADGES":
      return {
        ...state,
        athleteSoccerBadges: action.payload,
      };
    case "ATHLETE_VOLLEYBALL_BADGES":
      return {
        ...state,
        athleteVolleyballBadges: action.payload,
      };
    case "ATHLETE_TRACKANDFIELD_BADGES":
      return {
        ...state,
        athleteTrackandFieldBadges: action.payload,
      };
    case "ATHLETE_CROSSCOUNTRY_BADGES":
      return {
        ...state,
        athleteCrossCountryBadges: action.payload,
      };
    case "ATHLETE_TENNIS_BADGES":
      return {
        ...state,
        athleteTennisBadges: action.payload,
      };
    case "ATHLETE_WRESTLING_BADGES":
      return {
        ...state,
        athleteWrestlingBadges: action.payload,
      };
    case "ATHLETE_SOFTBALL_BADGES":
      return {
        ...state,
        athleteSoftballBadges: action.payload,
      };
    case "ATHLETE_SWIMMINGDIVING_BADGES":
      return {
        ...state,
        athleteSwimmingDivingBadges: action.payload,
      };
    case "ATHLETE_GOLF_BADGES":
      return {
        ...state,
        athleteGolfBadges: action.payload,
      };
    case "ATHLETE_COMPETITIVECHEERSPIRIT_BADGES":
      return {
        ...state,
        athleteCompetitiveCheerSpiritBadges: action.payload,
      };
    case "ATHLETE_LACROSSE_BADGES":
      return {
        ...state,
        athleteLacrosseBadges: action.payload,
      };
    case "ATHLETE_FLAGFOOTBALL_BADGES":
      return {
        ...state,
        athleteFlagFootballBadges: action.payload,
      };
    case "ATHLETE_BOWLING_BADGES":
      return {
        ...state,
        athleteBowlingBadges: action.payload,
      };
    case "ATHLETE_FIELDHOCKEY_BADGES":
      return {
        ...state,
        athleteFieldHockeyBadges: action.payload,
      };
    case "ATHLETE_WATERPOLO_BADGES":
      return {
        ...state,
        athleteWaterPoloBadges: action.payload,
      };
    case "ATHLETE_ICEHOCKEY_BADGES":
      return {
        ...state,
        athleteIceHockeyBadges: action.payload,
      };
    case "ATHLETE_WEIGHTLIFTING_BADGES":
      return {
        ...state,
        athleteWeightliftingBadges: action.payload,
      };
    case "ATHLETE_GYMNASTICS_BADGES":
      return {
        ...state,
        athleteGymnasticsBadges: action.payload,
      };
    case "ATHLETE_BEACHVOLLEYBALL_BADGES":
      return {
        ...state,
        athleteBeachVolleyballBadges: action.payload,
      };
    case "ATHLETE_SKIINGALPINESKIING_BADGES":
      return {
        ...state,
        athleteSkiingAlpineSkiingBadges: action.payload,
      };
    case "ATHLETE_BADMINTON_BADGES":
      return {
        ...state,
        athleteBadmintonBadges: action.payload,
      };
    case "ATHLETE_ESPORTS_BADGES":
      return {
        ...state,
        athleteEsportsBadges: action.payload,
      };
    case "ATHLETE_RUGBY_BADGES":
      return {
        ...state,
        athleteRugbyBadges: action.payload,
      };
    case "ATHLETE_ARCHERY_BADGES":
      return {
        ...state,
        athleteArcheryBadges: action.payload,
      };
    case "ATHLETE_FISHING_BADGES":
      return {
        ...state,
        athleteFishingBadges: action.payload,
      };
    case "ATHLETE_FENCING_BADGES":
      return {
        ...state,
        athleteFencingBadges: action.payload,
      };
    case "ATHLETE_OTHER_BADGES":
      return {
        ...state,
        athleteOtherBadges: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default seasonReducer;
